import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { noNeeds, oneSeed } from '../data/content';
export function MissionTransition() {
  return <section aria-labelledby="mission-title" className="bg-cream" data-id="element-205" data-mp="350s8jgt74b05">
      <div className="mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 lg:py-28" data-id="element-206" data-mp="3a2pxmroa2010">
        <h2 id="mission-title" className="font-display text-[40px] leading-[1.05] text-navy sm:text-[56px]" data-id="element-207" data-mp="3f116p06r06i6">
          Vous connaissez déjà la mission.
        </h2>
        <p className="mt-5 text-lg text-ink-soft" data-id="element-208" data-mp="2hb68kr501rr3">Jésus nous a déjà dit d’aller.</p>
        <p className="mt-8 text-lg text-ink-soft" data-id="element-209" data-mp="2ma10ciky2qnc">La question est :</p>
        <p className="mt-2 font-display text-[28px] leading-tight text-coral sm:text-[34px]" data-id="element-210" data-mp="2raeyn8wqum86">
          Allez-vous continuer à attendre le « moment parfait » pour commencer ?
        </p>
        <ul className="mx-auto mt-10 max-w-xl space-y-2 text-lg text-ink-soft" data-id="element-211" data-mp="1ylhsu59pyhwb">
          {noNeeds.map(n => <li key={n} data-id="element-212" data-mp="23kb5jvh6m4vf">{n}</li>)}
        </ul>
        <p className="mt-8 text-lg font-bold text-navy" data-id="element-213" data-mp="3krea4hwm6a8o">Vous pouvez commencer par quelque chose de simple.</p>
        <ol className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-214" data-mp="3fs2td8w8z4r3">
          {oneSeed.map((s, i) => <li key={s} className="flex items-center gap-3" data-id="element-215" data-mp="3b0jo9ena5cnr" data-mpi={i}>
              {i > 0 && <ArrowRightIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-216" data-mp="370sr8t75u0as" />}
              <span className={`font-display text-2xl sm:text-3xl ${i === oneSeed.length - 1 ? 'text-leaf-deep' : 'text-navy'}`} data-id="element-217" data-mp="32169q7katxw6">{s}</span>
            </li>)}
        </ol>
        <p className="mt-4 font-display text-2xl italic text-ink-soft" data-id="element-218" data-mp="2x4641xrd2x5l">Puis une autre.</p>
      </div>
    </section>;
}